import React from 'react'
import { Link } from 'gatsby'
import { scroll_top } from '../lib/window'
import { map_panel } from '../components/panel'
import Navigation from '../components/Navigation'

const ScmView = ({ model, lottiefiles, menu_state }) => {

  const panels = model ? model.panels.sort((x, y) => {
    return x.id - y.id
  }) : []
  const panel = model ? model.panel : null
  const page = model ? model : { name: '', Body: ''}

  return (
    <div id="scm-view" className="view">
      <header style={{ minHeight: 0 }}>
        <div className={menu_state}>
          <div className="py-2 bg-darkazul bg-opacity-80 text-white text-xl">
            <Navigation link_cls="hover:text-ice font-medium" />
          </div>
        </div>
        <div className="container px-4 lg:px-0">
        </div>
      </header>
      <main id="scm" className="text-texgray">
        {
          page.Body ?
          <div className="container">
            <p className="py-12">{page.Body}</p>
          </div>
          : null
        }
        {
          panels.length ?
          panels.map((panel, idx) => {
            return map_panel({ ...panel, lottiefiles: lottiefiles }, idx)
          })
          : null
        }
        {
          panel ?
          <div className="text-white bg-azul">
            <div className="container flex flex-wrap px-4 lg:px-0">
              <div className="w-full py-20">
                <div className="py-6 font-light text-center text-2xl lg:text-4xl">
                  {panel.body.split("\n").map((s, key) => {
                    return <span key={'rtf-' + key}>{s}<br /></span>
                  })}
                </div>
                <div className="flex justify-center">
                  <Link className="btn btn-default" to="/contact" onClick={scroll_top}>Enquire Now</Link>
                </div>
              </div>
            </div>
          </div>
          : null
        }
      </main>
    </div>
  )
}

export default ScmView